export default "__VITE_ASSET__CPonD_mf__"